import axios from "axios";
const instance = axios.create({
  baseURL: "https://messageapp-bhmf.onrender.com",
});
export default instance;
